export class HistContribuicao {
    iD_PESSOA: number;
    nR_ANO_REF: string;
    nR_MES_REF: string;
    nR_ANO_COMP: string;
    nR_MES_COMP: string;
    vL_CONTRIB: number;
}